export default {
  install(Vue) {
    Vue.prototype.$bus = new Vue()
  }
}



// WEBPACK FOOTER //
// ./src/lib/bus.js